

import Vue from "vue";
import Vuex from "vuex";

import VuexPersistence from "vuex-persist";

import authModule from "./modules/auth";
import dashboard from "./modules/dashboard";


/* global process */
const debug = process.env.NODE_ENV !== "production";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
  modules: [
    "auth",
  ],
  key: "ngb-state",
});

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  modules: {
    auth: authModule,
    dashboard: dashboard,
  },

  strict: debug,
});
